import PageContainer from "@/components/PageContainer";
import FeedCalculator from "@/components/FeedCalculator";

export default function CalculatorPage() {
  return (
    <PageContainer title="Kalkulator Pakan Sapi">
      <FeedCalculator withCost={false} />
    </PageContainer>
  );
}
